@if(logoOnly) {
  <div class="w-[36px] overflow-hidden text-left">
    <svg width="102" height="36" viewBox="0 0 102 36" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <rect width="102" height="36" fill="url(#pattern0_53136_16665)"/>
      <defs>
        <pattern id="pattern0_53136_16665" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlink:href="#image0_53136_16665" transform="scale(0.00294118 0.00833333)"/>
        </pattern>
        <image id="image0_53136_16665" width="340" height="120" preserveAspectRatio="none" [attr.xlink:href]="logoSrc"/>
      </defs>
    </svg>
  </div>

} @else {
  <svg width="142" height="50" viewBox="0 0 102 36" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <rect width="100" height="36" fill="url(#pattern0_53136_16665)"/>
    <defs>
      <pattern id="pattern0_53136_16665" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#image0_53136_16665" transform="scale(0.00294118 0.00833333)"/>
      </pattern>
      <image id="image0_53136_16665" width="340" height="120" preserveAspectRatio="none" [attr.xlink:href]="logoSrc"/>
    </defs>
  </svg>
}
